import { getDocs, query, getFirestore, collection, where, orderBy } from 'firebase/firestore';
import receiptRequestConverter from '../converters/receiptRequestConverter';
import { ReceiptRequestType } from "../types/ReceiptRequest";
import { RequestStatus } from "../types/Type";

export const queryReceiptRequests = async (type: ReceiptRequestType, status: RequestStatus | 'All' = 'New') => {
  const db = getFirestore();
  if (status === 'All') {
    const q = query(collection(db, 'ReceiptRequests'), where('type', '==', type))
      .withConverter(receiptRequestConverter);
    return (await getDocs(q)).docs.map((doc) => doc.data());
  }

  const q = query(collection(db, 'ReceiptRequests'), where('type', '==', type), where('status', '==', status))
    .withConverter(receiptRequestConverter);
  return (await getDocs(q)).docs.map((doc) => doc.data());
};

export const queryReceiptRequestsByIdNumber = async (idNumber: string, type: ReceiptRequestType) => {
  const db = getFirestore();
  const q = query(collection(db, `ReceiptRequests`), where('idNumber', '==', idNumber), where('type', '==', type), orderBy('dateRequested', 'desc')).withConverter(receiptRequestConverter);
  return (await getDocs(q)).docs.map((d) => d.data());
};